import { useState } from 'react';

import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from '@/components/ui/card';
import { Label } from '@/components/ui/label';
import { Switch } from '@/components/ui/switch';
import {
  isSessionRecordingOptedOut,
  setSessionRecordingOptOut,
} from '@/lib/session-recording-choice';

export function SessionRecordingSetting() {
  const [allowed, setAllowed] = useState(() => !isSessionRecordingOptedOut());
  return (
    <Card>
      <CardHeader>
        <CardTitle>Session recording</CardTitle>
        <CardDescription>
          We record how you use the app to find faults and improve the product,
          and send the recording to PostHog. Form inputs are hidden, but other
          text on screen can appear. Recordings expire after 30 days.
        </CardDescription>
      </CardHeader>
      <CardContent className="space-y-3">
        <div className="flex items-center justify-between gap-4">
          <Label htmlFor="session-recording">Allow session recording</Label>
          <Switch
            id="session-recording"
            checked={allowed}
            onCheckedChange={(value) => {
              setAllowed(value);
              setSessionRecordingOptOut(!value);
            }}
          />
        </div>
      </CardContent>
    </Card>
  );
}
